import { defineMessages } from 'react-intl';

export const messages: {
	benefitsSectionButtonMaybeLater: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionButtonTryItFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureDescriptionOperationalFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureDescriptionOperationalFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureDescriptionOperationalFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextAlertGroupingFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextAlertGroupingFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextAlertGroupingFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextJourneysFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextJourneysFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextJourneysFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextOperationalFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextOperationalFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextOperationalFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextWorkforceOptimizationFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextWorkforceOptimizationFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextWorkforceOptimizationFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTitleOperationalFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTitleOperationalFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTitleOperationalFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingAlertGrouping: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingChangeManagement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingHelpCenterCustomization: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingIncidentsSlackIntegration: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingJourneys: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingPlaybooks: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingPostIncidentReviews: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingProblemManagement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionLinkPricing: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionSubtitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionSubtitleContextualizedPremium: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonTriggerOpenModal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonTriggerTryItFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	benefitsSectionButtonMaybeLater: {
		id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
		defaultMessage: 'Maybe later',
		description:
			'Button in the edition benefits modal that allows the user to dismiss the upgrade prompt and return to it later.',
	},
	benefitsSectionButtonTryItFree: {
		id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
		defaultMessage: 'Try it free',
		description:
			'Primary call-to-action button in the edition benefits modal that initiates a free trial of Premium features.',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
		defaultMessage:
			'<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
		description: 'Text for first feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
		defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
		description: 'Text for second feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
		defaultMessage:
			'<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
		description: 'Text for third feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
		defaultMessage:
			'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
		description: 'Text for first feature in incidents-slack-integration variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
		defaultMessage:
			'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
		description: 'Text for second feature in incidents-slack-integration variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
		defaultMessage:
			'<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
		description: 'Text for third feature in incidents-slack-integration variant',
	},
	benefitsSectionFeatureTextWorkforceOptimizationFeature1: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1',
		defaultMessage:
			'Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.',
		description: 'Workforce Optimization feature row: scheduling',
	},
	benefitsSectionFeatureTextWorkforceOptimizationFeature2: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2',
		defaultMessage:
			"Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
		description: 'Workforce Optimization feature row: capacity utilization',
	},
	benefitsSectionFeatureTextWorkforceOptimizationFeature3: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3',
		defaultMessage:
			'Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.',
		description: 'Workforce Optimization feature row: real-time auto routing',
	},
	benefitsSectionHeadingHelpCenterCustomization: {
		id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
		defaultMessage: 'Try advanced Help Center customisation with Premium',
		description: 'Heading for help-center-customization variant',
	},
	benefitsSectionHeadingIncidentsSlackIntegration: {
		id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
		defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
		description: 'Heading for incidents-slack-integration variant',
	},
	benefitsSectionLinkPricing: {
		id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
		defaultMessage: 'See more Premium features and pricing',
		description:
			'Link in the edition benefits modal that navigates the user to a page listing Premium features and their pricing.',
	},
	benefitsSectionSubtitle: {
		id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
		defaultMessage:
			"Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
		description:
			'Subtitle displayed in the benefits section of the edition benefits modal, explaining the free trial offer for Premium features.',
	},
	buttonTriggerOpenModal: {
		id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
		defaultMessage: 'Open modal',
		description: 'Text for the button that opens the edition benefits modal',
	},
	buttonTriggerTryItFree: {
		id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
		defaultMessage: 'Try it free',
		description: 'Button text for to trigger opening the premium benefits modal',
	},
	benefitsSectionHeadingJourneys: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.journeys',
		defaultMessage: 'Try Journeys with Premium',
		description: 'Heading for the Journeys contextualised upgrade variant.',
	},
	benefitsSectionSubtitleContextualizedPremium: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.trial-description',
		defaultMessage: 'Try free for 30 days. We’ll remind you before it ends. Cancel anytime.',
		description: 'Subtitle for the Journeys contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextJourneysFeature1: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.self-service',
		defaultMessage:
			'<strong>Improve self service</strong> with AI-powered virtual agent and no-code journeys.',
		description: 'First feature row for the Journeys contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextJourneysFeature2: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.branded-front-door',
		defaultMessage:
			'<strong>Give every team a branded front door</strong> with multiple help centres',
		description: 'Second feature row for the Journeys contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextJourneysFeature3: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.track-team-dependencies',
		defaultMessage:
			'<strong>Track what your teams rely on</strong> with AI-driven workflows and up to 50,000 objects in Assets',
		description: 'Third feature row for the Journeys contextualised upgrade variant.',
	},
	benefitsSectionHeadingChangeManagement: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.change-management',
		defaultMessage: 'Try Change management with Premium',
		description: 'Heading for the change-management contextualised upgrade variant.',
	},
	benefitsSectionHeadingProblemManagement: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.problem-management',
		defaultMessage: 'Try Problem management with Premium',
		description: 'Heading for the problem-management contextualised upgrade variant.',
	},
	benefitsSectionHeadingPostIncidentReviews: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.post-incident-reviews',
		defaultMessage: 'Try Post-incident reviews with Premium',
		description: 'Heading for the post-incident-reviews contextualised upgrade variant.',
	},
	benefitsSectionHeadingPlaybooks: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.playbooks',
		defaultMessage: 'Try Playbooks with Premium',
		description: 'Heading for the playbooks contextualised upgrade variant.',
	},
	benefitsSectionFeatureTitleOperationalFeature1: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.title',
		defaultMessage: '<strong>Resolve incidents faster</strong>',
		description:
			'First benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureDescriptionOperationalFeature1: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.description',
		defaultMessage: 'AI-powered alerts group related incidents and surfaces root causes.',
		description:
			'First benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureTitleOperationalFeature2: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.title',
		defaultMessage: '<strong>Ship changes without the risk</strong>',
		description:
			'Second benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureDescriptionOperationalFeature2: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.description',
		defaultMessage: 'Automated risk scoring and approvals to keep your deploys safe.',
		description:
			'Second benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureTitleOperationalFeature3: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.title',
		defaultMessage: '<strong>Scale your services confidently</strong>',
		description:
			'Third benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureDescriptionOperationalFeature3: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.description',
		defaultMessage: '24/7 Premium support and unlimited storage keep your team moving.',
		description:
			'Third benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureTextOperationalFeature1: {
		id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature1',
		defaultMessage:
			'<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.',
		description:
			'First feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureTextOperationalFeature2: {
		id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature2',
		defaultMessage:
			'<strong>Ship changes safely</strong> with automated risk scoring and approvals.',
		description:
			'Second feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionFeatureTextOperationalFeature3: {
		id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature3',
		defaultMessage:
			'<strong>Scale your services confidently</strong> with 24/7 Premium support and unlimited storage.',
		description:
			'Third feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.',
	},
	benefitsSectionHeadingAlertGrouping: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.alert-grouping',
		defaultMessage: 'AI alert grouping with Premium',
		description: 'Heading for the AI alert grouping contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextAlertGroupingFeature1: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature1',
		defaultMessage:
			'<strong>Resolve incidents faster</strong> with AI-powered alerting, auto-grouping, and root cause analysis.',
		description: 'First feature row for the AI alert grouping contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextAlertGroupingFeature2: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature2',
		defaultMessage:
			'<strong>Deploy safely with AI risk scoring,</strong> automated approvals, and change calendars.',
		description: 'Second feature row for the AI alert grouping contextualised upgrade variant.',
	},
	benefitsSectionFeatureTextAlertGroupingFeature3: {
		id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature3',
		defaultMessage:
			'<strong>Scale confidently</strong> with 24/7 Premium Support, and unlimited storage.',
		description: 'Third feature row for the AI alert grouping contextualised upgrade variant.',
	},
});
